import React, { useState } from 'react';
import Menu from './Menu';
import Categories from './Categories';
import items from './data';
import './index.css';

// function App() {
//   const [menuItems, setMenuItems] = useState(items);
//   const [categories, setCategories] = useState([]);

//   return (
//     <main>
//       <section className='menu section'>
//         <div className='title'>
//           <h2>our menu</h2>
//           <div className='underline'></div>
//         </div>
//         <Categories />
//         <Menu items={menuItems} />
//       </section>
//     </main>
//   );
// }

// to display the button menu now

// function App() {
//   const [menuItems, setMenuItems] = useState(items);
//   const [categories, setCategories] = useState([]);

//   const fliterItems = (category) => {
//     const newItems = items.filter((item) => item.category === category);
//     setMenuItems(newItems);
//   };
//   return (
//     <main>
//       <section className='menu section'>
//         <div className='title'>
//           <h2>our menu</h2>
//           <div className='underline'></div>
//         </div>
//         <Categories fliterItems={fliterItems} />
//         <Menu items={menuItems} />
//       </section>
//     </main>
//   );
// }

// if menu items === all it should go back to all

// function App() {
//   const [menuItems, setMenuItems] = useState(items);
//   const [categories, setCategories] = useState([]);

//   const filterItems = (category) => {
//     if (category === 'all') {
//       return setMenuItems(items);
//     }
//     const newItems = items.filter((item) => item.category === category);
//     setMenuItems(newItems);
//   };
//   return (
//     <main>
//       <section className='menu section'>
//         <div className='title'>
//           <h2>our menu</h2>
//           <div className='underline'></div>
//         </div>
//         <Categories filterItems={filterItems} />
//         <Menu items={menuItems} />
//       </section>
//     </main>
//   );
// }

//NEW ONE to use map to bring out each button instead of creating buttons

const allCategories = ['all', ...new Set(items.map((item) => item.category))];

function App() {
  const [menuItems, setMenuItems] = useState(items);
  const [categories, setCategories] = useState(allCategories);

  const filterItems = (category) => {
    if (category === 'all') {
      return setMenuItems(items);
    }
    const newItems = items.filter((item) => item.category === category);
    setMenuItems(newItems);
  };
  return (
    <main>
      <section className='menu section'>
        <div className='title'>
          <h2>our menu</h2>
          <div className='underline'></div>
        </div>
        <Categories categories={categories} filterItems={filterItems} />
        <Menu items={menuItems} />
      </section>
    </main>
  );
}

export default App;
